import { layoutPrefixCls } from "@/base/components/layout/Layout.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Layout">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${layoutPrefixCls}`]: {},
  },
});

export const useLayoutStyle = genComponentStyleHook(
  ["Layout", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
